import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllAccount, revokeAdmin, updateFondiToAccount } from './supabase';
import Layout from './components/Layout';

const Soldi = () => {
    const [users, setUsers] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editValue, setEditValue] = useState('');
    const [currentUser, setCurrentUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [confirmTitle, setConfirmTitle] = useState('');
    const [confirmDescription, setConfirmDescription] = useState('');
    const [confirmAction, setConfirmAction] = useState(null);
    const getUsers = async () => {
        setLoading(true);
        const data = await getAllAccount();
        const sortByCreated = data.sort((a, b) => b.id - a.id);
        setUsers(sortByCreated);
        setLoading(false);
    };

    const filteredUsers = useMemo(() => {
        return users.filter(user =>
            user.nome.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [users, searchTerm]);

    const revoke = async (id, state) => {
        await revokeAdmin(id, state)
        getUsers()
    }

    const updateFondi = async (id, fondi, type, quantity) => {
        setLoading(true);
        console.log(type, quantity)
        if (type === 'add') {
            fondi = fondi + 1
        }

        if (quantity && type === 'remove') {
            fondi = fondi - quantity
        }

        if (type === 'reset') {
            fondi = quantity
        }

        await updateFondiToAccount(id, fondi)
        getUsers()
        setLoading(false);
    }

    const openConfirm = (title, description, action) => {
        setConfirmTitle(title);
        setConfirmDescription(description);
        setIsConfirmOpen(true);
        setConfirmAction(() => action);
    };

    const handleConfirm = async () => {
        if (confirmAction) {
            await confirmAction();
        }
        setIsConfirmOpen(false);
        setConfirmAction(null);
    };

    const handleCancelConfirm = () => {
        setIsConfirmOpen(false);
        setConfirmAction(null);
    };

    useEffect(() => {
        getUsers()
    }, [])

    const handleEditFondi = (user) => {
        setCurrentUser(user);
        setEditValue(user.fondi.toString());
        setEditMode(true);
    };

    const saveFondi = async () => {
        setLoading(true);
        if (!currentUser || !editValue) return;

        const newValue = parseFloat(editValue);
        if (isNaN(newValue)) {
            alert('Inserisci un valore numerico valido');
            return;
        }

        await updateFondiToAccount(currentUser.id, newValue);
        getUsers();
        setEditMode(false);
        setLoading(false);
    };

    return (
        <Layout>
            {loading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#839262]"></div>
                </div>
            )}
            <div className='flex w-full h-full flex-col overflow-scroll'>
                <div className='flex flex-1'>
                    <div className='flex flex-1 flex-col items-start'>
                        {/* Add search input */}
                        <div className='w-full mb-4 flex flex-row'>
                            <input
                                type='text'
                                placeholder='Cerca utente...'
                                className='bg-[#1A1919] text-white rounded-full py-3 px-6 w-full'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            {searchTerm && (
                                <button
                                    className='bg-[#1A1919] rounded-full px-5 text-white ml-1'
                                    onClick={() => setSearchTerm('')}
                                >
                                    ×
                                </button>
                            )}
                        </div>

                        <ul role="list" className="pb-36 w-full">
                            {filteredUsers.map((person) => (
                                <li key={person.id} className="bg-[#1E2021] w-full h-fit flex flex-col justify-between rounded-3xl p-4 mb-4 items-center">
                                    <div className='flex flex-row w-full justify-between'>
                                        <div className="flex min-w-0 gap-x-4">
                                            <div className="min-w-0 flex-auto">
                                                <p className="text-sm font-semibold leading-6 text-white">{person.nome}</p>
                                                {editMode && currentUser?.id === person.id ? (
                                                    <div className='flex flex-row'>
                                                        <input
                                                            type="number"
                                                            className="text-xl font-semibold leading-6 text-white bg-[#1A1919] border border-[#839262] rounded-full px-2 w-24"
                                                            value={editValue}
                                                            onChange={(e) => setEditValue(e.target.value)}
                                                        />

                                                        <div className='flex flex-row justify-between ml-2'>
                                                            <button
                                                                className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'
                                                                onClick={() => {
                                                                    const parsedValue = parseFloat(editValue);
                                                                    const displayValue = isNaN(parsedValue) ? editValue : parsedValue.toFixed(2);
                                                                    openConfirm(
                                                                        'Salva fondi',
                                                                        `Vuoi impostare il saldo di ${currentUser?.nome} a €${displayValue}?`,
                                                                        () => saveFondi()
                                                                    );
                                                                }}
                                                            >
                                                                ✅
                                                            </button>
                                                        </div>
                                                    </div>

                                                ) : (
                                                    <p className="text-xl font-semibold leading-6 text-white">€ {person.fondi}</p>
                                                )}
                                            </div>
                                        </div>

                                        <div className='w-fit flex flex-row justify-between'>
                                            {/* <div className="shrink-0 sm:flex sm:flex-col sm:items-end" onClick={() => updateFondi(person.id, person.fondi, 'add')}>
                                                <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'>+ Aggiungi fondi</button>
                                            </div> */}
                                            <div className="shrink-0 sm:flex sm:flex-col sm:items-end ml-2" onClick={() => handleEditFondi(person)}>
                                                <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full w-full'>+ Aggiungi fondi</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-3 w-full rounded-3xl gap-3 mt-6'>
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-4 px-4 rounded-[1.2rem] w-full'
                                            onClick={() =>
                                                openConfirm(
                                                    'Conferma operazione',
                                                    `Vuoi sottrarre €${(2).toFixed(2)} dal saldo di ${person.nome}?`,
                                                    () => updateFondi(person.id, person.fondi, 'remove', 2)
                                                )
                                            }
                                        >
                                            - €2.00
                                        </button>
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-4 px-4 rounded-[1.2rem] w-full'
                                            onClick={() =>
                                                openConfirm(
                                                    'Conferma operazione',
                                                    `Vuoi sottrarre €${(1.5).toFixed(2)} dal saldo di ${person.nome}?`,
                                                    () => updateFondi(person.id, person.fondi, 'remove', 1.5)
                                                )
                                            }
                                        >
                                            - €1.50
                                        </button>
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-4 px-4 rounded-[1.2rem] w-full'
                                            onClick={() =>
                                                openConfirm(
                                                    'Conferma operazione',
                                                    `Vuoi sottrarre €${(1).toFixed(2)} dal saldo di ${person.nome}?`,
                                                    () => updateFondi(person.id, person.fondi, 'remove', 1)
                                                )
                                            }
                                        >
                                            - €1.00
                                        </button>
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-4 px-4 rounded-[1.2rem] w-full'
                                            onClick={() =>
                                                openConfirm(
                                                    'Conferma operazione',
                                                    `Vuoi sottrarre €${(0.8).toFixed(2)} dal saldo di ${person.nome}?`,
                                                    () => updateFondi(person.id, person.fondi, 'remove', 0.8)
                                                )
                                            }
                                        >
                                            - €0.80
                                        </button>
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-4 px-4 rounded-[1.2rem] w-full'
                                            onClick={() =>
                                                openConfirm(
                                                    'Conferma operazione',
                                                    `Vuoi sottrarre €${(0.5).toFixed(2)} dal saldo di ${person.nome}?`,
                                                    () => updateFondi(person.id, person.fondi, 'remove', 0.5)
                                                )
                                            }
                                        >
                                            - €0.50
                                        </button>
                                        <button
                                            className='text-[#839262] border border-[#839262] font-bold py-4 px-4 rounded-[1.2rem] w-full'
                                            onClick={() =>
                                                openConfirm(
                                                    'Azzera fondi',
                                                    `Vuoi impostare il saldo di ${person.nome} a €0?`,
                                                    () => updateFondi(person.id, person.fondi, 'reset', 0)
                                                )
                                            }
                                        >
                                            To 0
                                        </button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            {isConfirmOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                    <div className="bg-[#1E2021] rounded-3xl p-6 w-11/12 max-w-md">
                        <h2 className="text-lg font-semibold text-white mb-2">{confirmTitle}</h2>
                        <p className="text-sm text-gray-300 mb-6">{confirmDescription}</p>
                        <div className="flex justify-end space-x-3">
                            <button
                                className="text-white border border-gray-500 font-bold py-2 px-4 rounded-full"
                                onClick={handleCancelConfirm}
                            >
                                Annulla
                            </button>
                            <button
                                className="text-[#1A1919] bg-[#839262] font-bold py-2 px-4 rounded-full"
                                onClick={handleConfirm}
                            >
                                Conferma
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default Soldi;
